import gettext from '@sdk/lang/gettext';

export type CustomerReview = {
  author: string;
  content: string;
};

/**
 * This set of customer reviews is approved to be displayed on premium preview pages.
 */
export default [
  {
    author: 'Andrew Luna, PAZ Veterinary',
    content: gettext(
      '"We are more efficient in scheduling and in running payroll with Sling. Geofencing for the time clock is a great feature and has helped us to avoid employee padding hours."'
    ),
  },
  {
    author: 'Eddie Dyer, Vessel Nola',
    content: gettext(
      '"Sling has helped to cut down on labor costs by making managers accountable for forecasting labor and then tracking against it. It has also prevented possible overtime issues while making scheduling more efficient in general."'
    ),
  },
];
